import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import LogoutIcon from "assets/ntat/icons/logout-modal-icon.svg";
import Button from "share/atoms/Button";

const LogoutModal = ({handleCancle=()=>{}, handleLogout=()=>{}}) => {
  return (
    <StyledModal show={true} centered>
      <Modal.Body>
        <img src={LogoutIcon} alt="logout-icon" />
        <h3 className="heading">Logout</h3>
        <span className="description">Are you sure you want to log out?</span>
        <div className="buttons-wrapper">
          <Button className="cancle-button" onClick={handleCancle}>Cancel</Button>
          <Button onClick={handleLogout}>Logout</Button>
        </div>
      </Modal.Body>
    </StyledModal>
  );
};

export default LogoutModal;

const StyledModal = styled(Modal)`
  .modal-content {
    padding: 16px 12px;
    border-radius: 16px;
    .modal-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      .heading {
        font-weight: 600;
        font-style: 600;
        font-size: 16px;
      }
      .description {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }
      
      .buttons-wrapper{
        display: flex;
        gap: 12px;
        align-items: center;
        margin-top: 20px;
        button{
            width: 106px;
            height: 40px;
            padding: 0;
            border-radius: 12px;
            font-size: 14px;
        }
        .cancle-button{
            background: transparent;
            color: #767676;
        }
      }
    }
  }
`;
